import { useCallback, useState } from "react";
import authApi, { Auth } from "../api/AuthAPI";
import { useHistory } from "react-router-dom";
import moment from "moment";
//import axios from "axios";
import useKeepLoginMachineLog from "./useKeepLoginMachineLog";
import KeepLoginMachineLog from "../models/KeepLoginMachineLog";
import platform from "platform";
import axios from "axios";


const useAuthAPI = () => {
  const [token, setToken] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const [alert, setAlert] = useState<boolean>(false);

  const [insertKeepLoginMachineLog,] = useKeepLoginMachineLog();

  const getToken = useCallback(
    async (auth: Auth) => {

      // device name
      let deviceName = "DeviceName";

      let ipRes = "";
      // load ip address from the API
      try {
        const ip = await axios.get("https://api.ipify.org?format=json");
        ipRes = ip.data.ip;
      } catch (error) {
        ipRes = "Get IP Addiess Error";
      }

      // device os
      let deviceOs: any = platform.description;

      // access time
      const accessTime = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");

      // web access
      const webAccess = "mycos-time-attendance-client";

      let log: KeepLoginMachineLog = {
        DeviceName: deviceName,
        DeviceIp: ipRes,
        DeviceOs: deviceOs,
        AccessTime: accessTime,
        WebAccess: webAccess
      }

      setLoading(true);

      try {
        const newToken = await authApi.getToken(auth);

        if (newToken.data !== "") {
          setToken(newToken.data);
          localStorage.setItem("token", newToken.data);
          insertKeepLoginMachineLog(log)
          history.push("/");
        }
        else {
          setAlert(true);
        }
      }
      catch (err) {
        setAlert(true);
      }

      setLoading(false);
    },
    [setLoading, setAlert, setToken, history, insertKeepLoginMachineLog]
  );

  return [loading, token, getToken, alert, setAlert] as const;
};

export default useAuthAPI;